<section class="content-header" style="padding: 0.5% !important;">
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-md-4">
                <ol class="breadcrumb float-sm-left">
                    <li class="breadcrumb-item">
                        <a [routerLink]="['/']"><i class="fas fa-home"></i> &nbsp;Trang chủ</a>
                    </li>
                    <li class="breadcrumb-item active">Tổng hợp điểm</li>
                </ol>
            </div>
            <div class="col-md-8">
                <button class="btn btn-info btn-sm" (click)="submit()" style="float: right; margin-right: 5px;">
                    <i class="fas fa-search"></i>Thống kê dữ liệu </button>
                    <button class="btn btn-success btn-sm" (click)="Excel()" style="float: right; margin-right: 5px;">
                        <i class="fas fa-file-excel"></i> Xuất excel 
                    </button>
                <button class="btn btn-info btn-sm" (click)="submit_xl()" style="float: right; margin-right: 5px;">
                    <i class="fas fa-search"></i>Thống kê xếp loại </button>
                    <button class="btn btn-success btn-sm" (click)="ExcelXepLoai()" style="float: right; margin-right: 5px;">
                        <i class="fas fa-file-excel"></i> Xuất excel xếp loại
                    </button>
                <button class="btn btn-info btn-sm" (click)="GetDataSV()" (click)="open(BangDiem)"
                    style="float: right; margin-right: 5px;">
                    <i class="fas fa-search"></i>Xem bảng điểm sinh viên
                </button>
                
                <button class="btn btn-warning btn-sm" type="submit" style="float: right;margin-right: 5px; ">
                    <i class="fas fa-info-circle"></i>
                    Hướng dẫn
                </button>
            </div>
        </div>
    </div>
</section>
<section class="content cus-body">
    <div class="card">
        <div class="card-body">
            <form class="form-horizontal" [formGroup]="filter">
                <div class="row">
                    <div class="col-md-2 ">
                        <label>Hệ</label>
                        <select class="form-control" (change)="changeHe()" formControlName="ID_he">
                            <option *ngFor="let i of dataHe" value="{{i.ID_he}}">{{i.Ten_he}}</option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label>Khoa</label>
                        <select class="form-control" formControlName="ID_khoa" (change)="changeKhoa()">
                            <option value="">Tất cả</option>
                            <option *ngFor="let i of dataKhoa" value="{{i.ID_khoa}}">{{i.Ten_khoa}}</option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label>Khóa</label>
                        <select class="form-control" formControlName="Khoa_hoc" (change)="changeKhoaHoc()">
                            <option value="">Tất cả</option>
                            <option *ngFor="let i of dataKhoaHoc2" value="{{i.Khoa_hoc}}">{{i.Khoa_hoc}}</option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label>Chuyên ngành</label>
                        <select class="form-control" formControlName="ID_chuyen_nganh" (change)="changeChuyenNganh()">
                            <option value="">Tất cả</option>
                            <option *ngFor="let i of dataChuyenNganh2" value="{{i.ID_chuyen_nganh}}">{{i.Chuyen_nganh}}
                            </option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label>Lớp</label>
                        <select class="form-control" formControlName="ID_lop">
                            <option value="">Tất cả</option>
                            <option *ngFor="let i of dataLop2" value="{{i.ID_lop}}">{{i.Ten_lop}}</option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <div class="form-check" style="margin-top: 30px; text-align: center;">
                            <input type="checkbox" style="width: 20px; height: 20px;" class="form-check-input"
                                formControlName="Hien_thi_ten_hoc_phan" />
                            <label class="form-check-label" style="margin-left: 5px;">Hiển thị tên học phần</label>
                        </div>
                    </div>
                    <!-- <label>Hiển thị</label>
                        <select class="form-control" formControlName="Hien_thi">
                            <option value="0">Thang điểm 10</option>
                            <option value="1">Thang điểm 4</option>
                            <option value="2">Thang điểm chữ</option>
                            <option value="3">Tất cả thang điểm</option>
                        </select> -->

                </div>
                <div class="row">
                    <div class="col-md-2">
                        <label>Thống kê</label>
                        <select class="form-control" formControlName="Loai_thong_ke" (change)="changeThongKe()">
                            <option value="0">Học kỳ, năm học</option>
                            <option value="1">Năm học</option>
                            <option value="2">Toàn khóa</option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label>Học kỳ</label>
                        <select class="form-control" formControlName="Hoc_ky">
                            <option value="1">Học kỳ I</option>
                            <option value="2">Học kỳ II</option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label>Năm học</label>
                        <select class="form-control" formControlName="Nam_hoc">
                            <option *ngFor="let i of Nam_hoc_arr" value="{{i.value}}">{{i.name}}</option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label>Điểm thi</label>
                        <select class="form-control" formControlName="Lan_thi">
                            <option value="0">Lần 1</option>
                            <option value="1">Cao nhất</option>

                        </select>
                    </div>

                    <div class="col-md-2">
                        <div class="form-check" style="margin-top: 30px; text-align: center;">
                            <input type="checkbox" style="width: 20px; height: 20px;" class="form-check-input"
                                formControlName="Ghi_chu_diem" />
                            <label class="form-check-label" style="margin-left: 5px;">Hiển thị ghi chú điểm thi</label>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-check" style="margin-top: 30px; text-align: center;">
                            <input type="checkbox" style="width: 20px; height: 20px;" class="form-check-input"
                                formControlName="Hien_thi_HP" />
                            <label class="form-check-label" style="margin-left: 5px;">Hiển thị HP không tính TBC</label>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</section>
<section class="content cus-body" *ngIf="isDisplay">
    <div class="card">
        <div class="card-body">
            <div class="table-responsive" style="width: 100%;height: auto; max-height: 50vh;">
                <table class="table table-bordered table-fixed" style="width: 100%;">
                    <thead>
                        <tr *ngFor="let i of dataHeader">
                            <ng-container *ngFor="let value of i.Cells">
                                <th *ngIf="value.Hide ==false" [attr.colspan]="value.Colspan"
                                    [attr.rowspan]="value.Rowspan">
                                    {{value.Name}}
                                </th>
                            </ng-container>
                        </tr>
                    </thead>
                    <tbody class="member">
                        <tr *ngFor="let val of dataTable; let i = index" (click)="ClickedRow(i)"
                            [class.active]="i == HighlightRow">
                            <ng-container *ngFor="let value of val.Value">
                                <td *ngIf="value.Hide ==false"
                                    [ngStyle]="{'font-weight':value.Bold != true ? '0' :'bold','text-align':value.Format}"
                                    (click)='SetID_sv(val.Value[1].Value,val.Value[2].Value,val.Value[3].Value,val.Value[4].Value)'>
                                    {{value.Value}}
                                </td>
                            </ng-container>
                        </tr>

                    </tbody>
                </table>
            </div>
            <span style="float:right"><b>Tổng số bản ghi</b>: {{recordTotal}}</span>
        </div>
    </div>
</section>
<!-- <section class="content cus-body" *ngIf="!isDisplay">
    <div class="card">
        <div class="card-body">
            <div id="chartContainer" style="height: 370px; width: 100%;"></div>
        </div>
    </div>
</section> -->
<ng-template #BangDiem let-modal>
    <h3 style="text-align: center;">{{Ten_sv}}-{{Ma_sv}}</h3>

    <div class="modal-content">
        <div class="modal-body">
            <div class="row">
                <div class="col-md-4 ">
                    <label>TBCHT(4)</label>
                    <input class="form-control" type="text" readonly value="{{lblTBCHT4}}" />
                </div>
                <div class="col-md-4">
                    <label>TBCHT(10)</label>
                    <input class="form-control" type="text" readonly value="{{lblTBCHT10}}" />
                </div>
                <div class="col-md-4">
                    <label>TBCHT tích luỹ</label>
                    <input class="form-control" type="text" readonly value="{{lblTBC_tich_luy}}" />
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <label>Xếp loại học tập 4</label>
                    <input class="form-control" type="text" readonly value="{{lblXep_loai_hoc_tap4}}" />
                </div>
                <div class="col-md-4">
                    <label>Xếp loại học tập</label>
                    <input class="form-control" type="text" readonly value="{{lblXep_loai_hoc_tap10}}" />
                </div>
                <div class="col-md-4">
                    <label>Xếp hạng học lực</label>
                    <input class="form-control" type="text" readonly value="{{lblXep_hang_hoc_luc}}" />
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <label>Số môn học lại</label>
                    <input class="form-control" type="text" readonly value="{{lblSo_mon_hoc_lai}}" />
                </div>
                <div class="col-md-4">
                    <label>Số môn thi lại</label>
                    <input class="form-control" type="text" readonly value="{{lblSo_mon_thi_lai}}" />
                </div>
                <div class="col-md-4">
                    <label>Số tín chỉ đã tích luỹ</label>
                    <input class="form-control" type="text" readonly value="{{lblSo_tin_chi_tich_luy}}" />

                </div>
            </div>
        </div>
        <div class="modal-body">
            <div class="card">
                <div class="card-body">
                    <div class="table-responsive" style="width: 100%;height: auto; max-height: 50vh;">
                        <table class="table table-bordered table-fixed" style="width: 100%;">
                            <thead>
                                <tr *ngFor="let i of dataHeaderSV">
                                    <th *ngFor="let value of i.Cells">
                                        {{value.Name}}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let i of dataTableSV">
                                    <td *ngFor="let value of i.Value">
                                        {{value.Value}}
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="text-right">
                <button type="button" class="btn btn-md btn-danger" (click)="modal.dismiss('Cross click')"
                    style="margin-left: 1em;">
                    Thoát
                </button>
            </div>
        </div>
    </div>
</ng-template>